import React, { Fragment } from 'react'
import { Row, Col, Form, Button } from 'react-bootstrap'
import formatCpf from '@brazilian-utils/format-cpf'
import { isValidCpf } from '@brazilian-utils/is-valid-cpf'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import moment from 'moment'
import 'moment/locale/pt-br'

import { handleDecimalConvert } from '../../../utils/string.utils'
import { tiposTelefone } from '../../../constants/telefones.constants'
import { Enderecos } from '../../Common'
import PermissoesConstants from '../../../constants/permissoes.constants'
import MenuContext from '../../../contexts/MenuContexts'
import { toast } from 'react-toastify'
import SharedService from '../../../services/shared.service'
import { pacienteFormStyles } from './PacienteFormStyles'
import EmailsSection from './emails/EmailsSection'
import DependentesSection from './dependentes/DependentesSection'
import DadosPessoaisSection from './dadosPessoais/DadosPessoaisSection'
import EnderecoSection from './endereco/EnderecoSection'
import OutrasInformacoesSection from './outrasInformacoes/OutrasInformacoesSection'
import FiliacaoSection from './filiacao/FiliacaoSection'
import ObservacaoSection from './observacao/ObservacaoSection'
import FormChrome from './form/FormChrome'
import TelefonesPacienteSection from './TelefonesPacienteSection'

const cpfMask = [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/]

class PacienteForm extends React.Component {
  state = this.initialState

  get initialState() {
    const telefonesExistentes =
      this.props.paciente.telefones && this.props.paciente.telefones.length > 0
        ? [...this.props.paciente.telefones]
        : []
    return {
      observacao: this.props.paciente.observacao || '',
      cpf: this.props.paciente.cpf || '',
      rg: '',
      nome: this.props.paciente.nome || '',
      nomeSocial: this.props.paciente.nomeSocial || '',
      dataNascimento: null,
      nomePai: '',
      nomeMae: '',
      telefones: telefonesExistentes,
      enderecos: [{}],
      emails: [],
      dependentes: [],
      localTrabalho: '',
      renda: '0',
      outrasRendas: '0',
      nomeConjuge: '',
      invalidCPF: false,
      agendamentoId: this.props.paciente.agendamentoId,
      camposBloqueados: true,
      carregandoDados: false,
      mobileMenuOpen: false,
      modalEmailIndex: null,
      modalDependenteIndex: null,
      telefoneModalOpen: false,
    }
  }

  static getDerivedStateFromProps(props, state) {
    const { paciente } = props
    if (paciente && paciente.id && !state.id) {
      const toUpdate = { ...paciente }
      toUpdate.cpf = formatCpf(toUpdate.cpf)
      toUpdate.telefones = paciente.telefones ? [...paciente.telefones] : []
      toUpdate.camposBloqueados = false // Desbloquear campos para edição
      return toUpdate
    }
    return null
  }

  onChange = (e) => {
    const { name, value } = e.target
    this.setState({ [name]: value })
  }

  onChangeRenda = (e) => {
    this.setState({
      renda: e,
    })
  }

  onChangeOutrasRendas = (e) => {
    this.setState({
      outrasRendas: e,
    })
  }

  onBlurCPF = async (e) => {
    this.onChange(e)
    const cpfValue = e.target.value.replace(/\D/g, '') // Remove formatação
    const isValid = isValidCpf(e.target.value) && e.target.value.length > 0
    
    this.setState({ invalidCPF: !isValid })
    
    if (isValid && cpfValue.length === 11) {
      await this.buscarDadosPorCPF(cpfValue)
    }
  }

  buscarDadosPorCPF = async (cpf) => {
    try {
      this.setState({ carregandoDados: true })
      const response = await SharedService.buscarDadosPeloCpf(cpf)
      
      if (response.data) {
        this.preencherDadosDaAPI(response.data)
        toast('Dados encontrados e preenchidos automaticamente!', { type: toast.TYPE.SUCCESS })
      }
    } catch (error) {
      console.error('Erro ao buscar dados por CPF:', error)
      toast('Erro ao buscar dados do CPF. Verifique se o CPF está correto.', { type: toast.TYPE.ERROR })
    } finally {
      this.setState({ 
        carregandoDados: false,
        camposBloqueados: false 
      })
    }
  }

  preencherDadosDaAPI = (dados) => {
    const telefones = []
    
    if (dados.telefones && dados.telefones.length > 0) {
      dados.telefones.forEach((tel, index) => {
        telefones.push({
          principal: index === 0,
          numero: `(${tel.ddd}) ${tel.numero}`,
          nomeContato: dados.nome,
          tipoTelefone: index === 1 ? tiposTelefone.TRABALHO : tiposTelefone.PESSOAL
        })
      })
    }
    
    const enderecos = []
    if (dados.enderecos && dados.enderecos.length > 0) {
        enderecos.push({
          cep: dados.enderecos?.[0].cep,
          logradouro: dados.enderecos?.[0].logradouro,
          numero: dados.enderecos?.[0].numero,
          complemento: dados.enderecos?.[0].complemento,
          bairro: dados.enderecos?.[0].bairro,
          cidade: dados.enderecos?.[0].cidade,
          estado: dados.enderecos?.[0].estado
        })
    }
    
    if (enderecos.length === 0)
      enderecos.push({})

    const emails = []

    if (dados.emails && dados.emails.length > 0)
      dados.emails.forEach(email => emails.push({endereco: email}))

    let renda = '0'

    if (dados.rendaPresumida && dados.rendaPresumida.valorRenda)
      renda = dados.rendaPresumida?.valorRenda?.toString().replace('.', ',') || '0'

    this.setState({
      nome: dados.nome || '',
      dataNascimento: dados.dataNascimento ? moment(dados.dataNascimento) : null,
      nomeMae: dados.nomeMae || '',
      telefones: telefones,
      enderecos: enderecos,
      emails: emails,
      renda: renda,
      localTrabalho: dados.experienciasProfissionais && dados.experienciasProfissionais.length > 0 
        ? dados.experienciasProfissionais?.[0].razaoSocial 
        : (dados.sociedades && dados.sociedades.length > 0 
          ? dados.sociedades?.[0].razaoSocial 
          : '')
    })
  }

  onChangeDate = (dataNascimento) => this.setState({ dataNascimento })

  onSubmit = async (e) => {
    e.preventDefault()

    if (this.state.invalidCPF) {
      toast('CPF inválido!', { type: toast.TYPE.ERROR })
    } else {
      let data = {
        ...this.state,
        renda: handleDecimalConvert(this.state.renda),
        outrasRendas: handleDecimalConvert(this.state.outrasRendas),
        ativo: true,
        id: this.props.paciente.id ? this.props.paciente.id : undefined,
        dependentes: this.state.dependentes.filter((d) => Object.keys(d).length > 0),
        dataNascimento: moment.isMoment(this.state.dataNascimento)
          ? this.state.dataNascimento.toDate()
          : this.state.dataNascimento,
      }
      data.telefones = []
      data.emails.forEach((email, index) => {
        if (Object.keys(email).length === 0 && email.constructor === Object) {
          data.emails.splice(index, 1)
        }
      })

     await this.props.salvar(data)
    }
  }

  addEmail = () => {
    const emails = [...this.state.emails, {}]
    this.setState({ emails, modalEmailIndex: emails.length - 1 })
  }

  setEmail = (index, email) => {
    const emails = [...this.state.emails]
    emails[index] = email
    this.setState({ emails })
  }

  removeEmail = (index) => {
    const emails = [...this.state.emails]
    emails.splice(index, 1)
    this.setState((prev) => ({
      emails,
      modalEmailIndex:
        prev.modalEmailIndex === null
          ? null
          : prev.modalEmailIndex === index
            ? null
            : prev.modalEmailIndex > index
              ? prev.modalEmailIndex - 1
              : prev.modalEmailIndex,
    }))
  }

  onFileChange = (index, file) => { }

  addEndereco = () => {
    let enderecos = this.state.enderecos || []
    enderecos.push({})
    this.setState({
      enderecos,
    })
  }

  setEndereco = (index, endereco) => {
    const enderecos = [...this.state.enderecos]
    enderecos[index] = endereco
    this.setState({ enderecos })
  }

  removeEndereco = (index) => {
    let enderecos = [...this.state.enderecos]
    enderecos.splice(index, 1)
    this.setState({
      enderecos,
    })
  }

  renderEndereco(index, endereco, disableAll = false, isPacienteCadastrado = false) {
    return (
      <div key={index}>
        <Enderecos
          needHomeProof
          endereco={endereco}
          index={index}
          onFileChange={this.onFileChange}
          onChange={this.setEndereco}
          disableAll={disableAll}
        />
        <Row>
          <Col>
            {index > 0 && endereco.cep && !disableAll && !isPacienteCadastrado && (
              <Button onClick={() => this.removeEndereco(index)} className='mr-3' variant='danger'>
                <FontAwesomeIcon icon={faTrashAlt} />
              </Button>
            )}
          </Col>
        </Row>
      </div>
    )
  }

  addDependentes = () => {
    const dependentes = [
      ...this.state.dependentes,
      {
        nome: '',
        dataNascimento: new Date().toISOString(),
        cpf: '',
        rg: '',
      },
    ]
    this.setState({ dependentes, modalDependenteIndex: dependentes.length - 1 })
  }

  closeModalEmail = () => this.setState({ modalEmailIndex: null })
  closeModalDependente = () => this.setState({ modalDependenteIndex: null })

  openTelefoneModal = () => {
    const id = this.props.paciente && this.props.paciente.id
    if (!id) {
      toast('Salve o paciente antes de adicionar telefone.', { type: toast.TYPE.WARNING })
      return
    }
    this.setState({ telefoneModalOpen: true })
  }

  closeTelefoneModal = () => this.setState({ telefoneModalOpen: false })

  setDependente = (index, dependente) => {
    const dependentes = [...this.state.dependentes]
    dependentes[index] = dependente
    this.setState({ dependentes })
  }
  
  removeDependente = (index) => {
    const dependentes = [...this.state.dependentes]
    dependentes.splice(index, 1)
    this.setState((prev) => ({
      dependentes,
      modalDependenteIndex:
        prev.modalDependenteIndex === null
          ? null
          : prev.modalDependenteIndex === index
            ? null
            : prev.modalDependenteIndex > index
              ? prev.modalDependenteIndex - 1
              : prev.modalDependenteIndex,
    }))
  }

  openMobileMenu = () => this.setState({ mobileMenuOpen: true })

  closeMobileMenu = () => this.setState({ mobileMenuOpen: false })

  componentDidUpdate(_prevProps, prevState) {
    if (this.state.mobileMenuOpen && !prevState.mobileMenuOpen) {
      if (typeof document !== 'undefined') {
        document.body.style.overflow = 'hidden'
        this._mobileMenuEsc = (e) => {
          if (e.key === 'Escape') this.closeMobileMenu()
        }
        document.addEventListener('keydown', this._mobileMenuEsc)
      }
    }
    if (!this.state.mobileMenuOpen && prevState.mobileMenuOpen) {
      if (typeof document !== 'undefined') {
        document.body.style.overflow = ''
        if (this._mobileMenuEsc) {
          document.removeEventListener('keydown', this._mobileMenuEsc)
          this._mobileMenuEsc = null
        }
      }
    }
  }

  componentWillUnmount() {
    if (typeof document !== 'undefined') {
      document.body.style.overflow = ''
      if (this._mobileMenuEsc) document.removeEventListener('keydown', this._mobileMenuEsc)
    }
  }

  componentDidUpdate(prevProps) {
    const id = this.props.paciente && this.props.paciente.id
    if (
      id &&
      prevProps.paciente &&
      this.props.paciente.telefones !== prevProps.paciente.telefones
    ) {
      this.setState({
        telefones: this.props.paciente.telefones ? [...this.props.paciente.telefones] : [],
      })
    }
  }

  render() {
    let acoesPermitidas = {}
    const isPacienteCadastrado = this.props.paciente && this.props.paciente.id
    
    return (
      <MenuContext.Consumer>
        {(acoes) => {
          acoes.map((a) => {
            acoesPermitidas[`${a.nome}`] = a
            return true
          })
          const allDisabled =
            !acoesPermitidas[PermissoesConstants.EDITAR] ||
            this.state.camposBloqueados ||
            isPacienteCadastrado
          const cpfDisabled = isPacienteCadastrado || (!acoesPermitidas[PermissoesConstants.EDITAR])

          const canAddItems = !!acoesPermitidas[PermissoesConstants.EDITAR]
          // Telefones não usam `allDisabled`: ele inclui `isPacienteCadastrado` e esconderia ações para paciente já salvo.
          const canEditTelefones = canAddItems && !this.state.camposBloqueados
          return (
            <Form className="py-2 paciente-form paciente-form--fab-mobile-pad" onSubmit={this.onSubmit}>
              <style>{pacienteFormStyles}</style>
              <DadosPessoaisSection
                cpfMask={cpfMask}
                cpf={this.state.cpf}
                nome={this.state.nome}
                nomeSocial={this.state.nomeSocial}
                rg={this.state.rg}
                dataNascimento={this.state.dataNascimento}
                invalidCPF={this.state.invalidCPF}
                carregandoDados={this.state.carregandoDados}
                camposBloqueados={this.state.camposBloqueados}
                pacienteId={this.props.id}
                allDisabled={allDisabled}
                cpfDisabled={cpfDisabled}
                onChange={this.onChange}
                onBlurCPF={this.onBlurCPF}
                onChangeDate={this.onChangeDate}
              />

              <EnderecoSection>
                {(this.state.enderecos || []).map((endereco, index) =>
                  this.renderEndereco(index, endereco, allDisabled, isPacienteCadastrado)
                )}
              </EnderecoSection>

              <OutrasInformacoesSection
                localTrabalho={this.state.localTrabalho}
                renda={this.state.renda}
                outrasRendas={this.state.outrasRendas}
                allDisabled={allDisabled}
                onChange={this.onChange}
                onChangeRenda={this.onChangeRenda}
                onChangeOutrasRendas={this.onChangeOutrasRendas}
              />

              <FiliacaoSection
                nomeMae={this.state.nomeMae}
                nomePai={this.state.nomePai}
                nomeConjuge={this.state.nomeConjuge}
                allDisabled={allDisabled}
                onChange={this.onChange}
              />

              {isPacienteCadastrado && (
                <TelefonesPacienteSection
                  telefones={this.props.paciente.telefones || []}
                  pacienteId={this.props.paciente.id}
                  canEdit={canEditTelefones}
                  onRefresh={this.props.refreshPaciente}
                  showModal={this.state.telefoneModalOpen}
                  onCloseModal={this.closeTelefoneModal}
                />
              )}

              {this.state.emails.length > 0 && (
                <Fragment>
                  <Row className="mt-3 pt-2">
                    <Col>
                      <h2 className="paciente-form-section-title mb-0">E-mails</h2>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={12}>
                      <EmailsSection
                        emails={this.state.emails}
                        modalEmailIndex={this.state.modalEmailIndex}
                        isPacienteCadastrado={isPacienteCadastrado}
                        canAddItems={canAddItems}
                        onSetModalEmailIndex={(index) => this.setState({ modalEmailIndex: index })}
                        onCloseModalEmail={this.closeModalEmail}
                        setEmail={this.setEmail}
                        removeEmail={this.removeEmail}
                      />
                    </Col>
                  </Row>
                </Fragment>
              )}

              {this.state.dependentes.length > 0 && (
                <Fragment>
                  <Row className="mt-3 pt-2 mb-1">
                    <Col>
                      <h2 className="paciente-form-section-title mb-0">Dependentes</h2>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={12}>
                      <DependentesSection
                        dependentes={this.state.dependentes}
                        modalDependenteIndex={this.state.modalDependenteIndex}
                        isPacienteCadastrado={isPacienteCadastrado}
                        canAddItems={canAddItems}
                        onSetModalDependenteIndex={(index) => this.setState({ modalDependenteIndex: index })}
                        onCloseModalDependente={this.closeModalDependente}
                        setDependente={this.setDependente}
                        removeDependente={this.removeDependente}
                      />
                    </Col>
                  </Row>
                </Fragment>
              )}

              <ObservacaoSection observacao={this.state.observacao} onChange={this.onChange} />

              <FormChrome
                canAddItems={canAddItems}
                isPacienteCadastrado={isPacienteCadastrado}
                allDisabled={allDisabled}
                mobileMenuOpen={this.state.mobileMenuOpen}
                onOpenMobileMenu={this.openMobileMenu}
                onCloseMobileMenu={this.closeMobileMenu}
                onAddEmail={this.addEmail}
                onAddDependentes={this.addDependentes}
                onAddTelefone={canEditTelefones && isPacienteCadastrado ? this.openTelefoneModal : undefined}
                onHandleCancel={this.props.handleCancel}
              />
            </Form>
          )
        }}
      </MenuContext.Consumer>
    )
  }
}

export default PacienteForm
